import React from 'react';
import styled from 'styled-components';

const Toggle = styled.div`
  display: inline-flex;
  padding: 0.3rem;
  border-radius: 999px;
  background: ${p => p.theme.low};
  gap: 0.25rem;
`;

const Option = styled.button`
  border: 0;
  border-radius: 999px;
  padding: 0.7rem 1.2rem;
  font: inherit;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  color: ${p => p.active ? p.theme.white : p.theme.dark};
  background: ${p => p.active ? p.theme.main : 'transparent'};
  transition: background 160ms ease, color 160ms ease;
`;

export default function Statistics_Grouping_Toggle({ groupBy, onChange }) {
  return <Toggle aria-label="Statistics grouping">
    <Option type="button" active={groupBy === 'subscription'} onClick={() => onChange('subscription')}>Per subscription</Option>
    <Option type="button" active={groupBy === 'customer'} onClick={() => onChange('customer')}>Per customer</Option>
  </Toggle>;
}
